import { useState, useEffect } from "react";
import { X } from "@phosphor-icons/react";

const InstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    // Check if already dismissed or in standalone mode
    const dismissed = localStorage.getItem("pwa-install-dismissed");
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
    
    if (dismissed || isStandalone) return;

    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show prompt after 30 seconds on first visit
      setTimeout(() => setShowPrompt(true), 30000);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstall);
    return () => window.removeEventListener("beforeinstallprompt", handleBeforeInstall);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === "accepted") {
      setShowPrompt(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem("pwa-install-dismissed", "true");
  };

  if (!showPrompt) return null;

  return (
    <div className="install-prompt">
      <button 
        onClick={handleDismiss}
        className="absolute top-3 right-3 text-[#78716C]"
      >
        <X size={20} />
      </button>
      <h3 className="font-heading font-semibold text-lg mb-1" style={{color: 'var(--charcoal)'}}>
        Add ETHOS to Home Screen
      </h3>
      <p className="text-sm text-[#78716C] mb-4">
        Get the full app experience with quick access.
      </p>
      <div className="flex gap-3">
        <button 
          onClick={handleDismiss}
          className="flex-1 h-10 rounded-full border border-[#E6E2DA] text-sm"
        >
          Not now
        </button>
        <button 
          onClick={handleInstall}
          className="flex-1 h-10 rounded-full text-white text-sm"
          style={{backgroundColor: 'var(--amethyst)'}}
        >
          Install
        </button>
      </div>
    </div>
  );
};

export default InstallPrompt;
